import { createI18n } from "vue-i18n";
import es from "./locales/es";
import en from "./locales/en";

export default createI18n({
  legacy: false,
  locale: "es", // Por defecto español
  fallbackLocale: "es",
  messages: {
    es,
    en,
  },
});
